/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import React, { useEffect, useState } from 'react';
import { Modal } from "react-bootstrap";
import { useDispatch } from 'react-redux';
import { ResponseResult } from '../../apis/response';
import MODAL_ARROW_ICON from '../../assets/images/modal_arrow.png';
import { csmsGetApiKey, csmsRequestMembercard } from '../../stores/actions/csms_action';
import { disabled_gray2 } from '../../styles/colors';
import { BtnOutLineBlue } from '../../styles/themes';
import { serverErrAlertMessage } from '../../validations/messages/messages';

const resolveRdnmadr = (rdnmadr, adres) => (rdnmadr && rdnmadr !== "-") ? rdnmadr : adres;

const buildAddressDisplay = (rdnmadr, adres, adresDetail) => {
    const base = resolveRdnmadr(rdnmadr, adres);
    return [base, adresDetail].filter(part => part && part !== "-").join(" ");
}

export default function ModalMembercardRequest(props) {
    const dispatch = useDispatch();
    const [IsComplete, setIsComplete] = useState(false);
    const [Success, setSuccess] = useState(false);
    const [ResultMsg, setResultMsg] = useState("");
    const [Requesting, setRequesting] = useState(false);

    useEffect(() => {
        if (!props.show) {
            const timer = setTimeout(() => {
                setIsComplete(false);
                setRequesting(false);
            }, 500);
            return () => clearTimeout(timer);
        }
    }, [props.show]);

    const onClickRequestHandler = async () => {
        setRequesting(true);
        try {
            // 신청 시점에 토큰을 새로 발급받아 사용 (페이지 진입 시 받은 토큰은 클릭 시점까지 만료됐을 수 있음)
            const tokenResponse = await dispatch(csmsGetApiKey());
            if (!tokenResponse.payload || !tokenResponse.payload.data) {
                setSuccess(false);
                setResultMsg(serverErrAlertMessage);
                setIsComplete(true);
                return;
            }
            const csmsToken = tokenResponse.payload.data.accessToken;

            const response = await dispatch(csmsRequestMembercard({
                "cloudId": props.cloudId,
                "rdnmadr": props.rdnmadr,
                "adres": props.adres,
                "adresDetail": props.adresDetail,
            }, csmsToken));

            const isSuccess = response.payload.result === ResponseResult.OK;
            setSuccess(isSuccess);
            setResultMsg(isSuccess
                ? "실물카드 신청이 완료되었습니다.\n실물카드는 신청일로부터 영업일 기준 10일 이내로 배송됩니다."
                : response.payload.msg);
            setIsComplete(true);
        } catch (e) {
            setSuccess(false);
            setResultMsg(serverErrAlertMessage);
            setIsComplete(true);
        } finally {
            setRequesting(false);
        }
    }

    const onClickResultConfirmHandler = () => {
        if (Success) {
            window.location.reload();
        } else {
            setIsComplete(false);
        }
    }

    return (
        <Modal
            show={props.show}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            autoFocus
            fullscreen="md-down"
            className={!IsComplete ? "mypage-modal" : "mypage-modal-alert"}
            css={css`.modal-content { height: auto !important; }`}
            onHide={props.onHide}
        >
            <div className="title">
                <img src={MODAL_ARROW_ICON} onClick={props.onHide} alt="close_icon" css={css`&:hover{cursor:pointer}`} />
                <h1>{!IsComplete ? "실물카드 배송 신청 안내" : (Success ? "실물카드 신청 완료" : "실물카드 신청 실패")}</h1>
            </div>
            <Modal.Body className="container1 text-center">
                {
                    !IsComplete
                        ? <React.Fragment>
                            <div css={css`font-weight: 400; font-size: 16px; line-height: 24px; color: ${disabled_gray2}; white-space: pre-line;`}>
                                {"등록된 주소로 실물카드가 발송됩니다.\n신청 후에는 취소가 어려우니 주소를 다시 한번 확인해주세요.\n[배송 정보 : " + buildAddressDisplay(props.rdnmadr, props.adres, props.adresDetail) + "]"}
                            </div>
                            <div css={css`width: 100%; padding-top: 32px; display: flex; justify-content: space-around`}>
                                <button type="button" onClick={props.onHide} css={[BtnOutLineBlue, css`width: 45%; height: 48px;`]}>아니오</button>
                                <button type="button" disabled={Requesting} onClick={onClickRequestHandler} css={[BtnOutLineBlue, css`width: 45%; height: 48px;`]}>예</button>
                            </div>
                        </React.Fragment>
                        : <React.Fragment>
                            <div css={css`font-weight: 400; font-size: 16px; line-height: 24px; white-space: pre-line;`}>
                                {ResultMsg}
                            </div>
                            <div css={css`width: 200px; padding: 45px 0; margin: 0 auto;`}>
                                <button onClick={onClickResultConfirmHandler} css={[BtnOutLineBlue, css` height: 48px;`]}>확인</button>
                            </div>
                        </React.Fragment>
                }
            </Modal.Body>
        </Modal>
    );
};
